import { useModel as _useModel, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = { class: "add-new-option-container" };
import { ref, computed, h, onMounted, } from "vue";
import { useStore } from "@/store";
import CustomSVG from "@/components/custom/CustomSVG.vue";
import { NButton, NIcon, NInput } from "naive-ui";
import api from "@/utils/api";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TagSelector',
    props: {
        "bindValue": {
            type: Array,
            required: true,
        },
        "bindValueModifiers": {},
    },
    emits: ["update:bindValue"],
    setup: function (__props) {
        var store = useStore();
        // const emit = defineEmits(["update:bind-value"]);
        // const props = defineProps({
        //   bindValue: Array as PropType<string[]>,
        // });
        // const selectedTags = toRef(props.bindValue);
        // watch(selectedTags, (newValue) => {
        //   // 当 bindValue 发生变化时，触发 update:bind-value 事件
        //   console.log("selectedTags Update ==============================", newValue);
        //   emit("update:bind-value", newValue); // 双向绑定受控，发送事件使得传来的值能发生变化
        // });
        var selectedTags = _useModel(__props, "bindValue");
        var newTagInput = ref("");
        var tagsOptions = ref([]);
        api.requestWithoutMask.get("/taglist").then(function (res) {
            tagsOptions.value = res.data;
        });
        var tagsRenderOptions = computed(function () {
            return tagsOptions.value.map(function (item) {
                return {
                    label: item,
                    value: item,
                };
            });
        });
        var addNewTag = function () {
            if (newTagInput.value.trim() === "") {
                window.$message.error("标签不能为空");
                return;
            }
            if (tagsOptions.value.includes(newTagInput.value)) {
                window.$message.error("标签已存在");
                return;
            }
            api.request
                .quickPost("/addtag", {
                tag: newTagInput.value,
            })
                .then(function (res) {
                if (selectedTags.value === undefined) {
                    window.$notifyError("标签初始化有误", "tag数组为 undefined");
                    return;
                }
                window.$msgSuccess("添加成功");
                tagsOptions.value.push(newTagInput.value);
                selectedTags.value.push(newTagInput.value);
                newTagInput.value = "";
            })
                .catch(function (err) {
                window.$message.error("添加失败");
            });
        };
        var deleteOption = function (tag) {
            api.request
                .quickPost("/deletetag", {
                tag: tag,
            })
                .then(function (res) {
                var index = tagsOptions.value.indexOf(tag);
                if (index > -1) {
                    tagsOptions.value.splice(index, 1);
                    window.$message.success("删除成功");
                }
                else {
                    window.$message.error("列表出错");
                    return;
                }
                if (selectedTags.value === undefined) {
                    window.$notifyError("删除时标签初始化有误", "tag数组为 undefined");
                    return;
                }
                if (selectedTags.value.includes(tag)) {
                    var selectedIndex = selectedTags.value.indexOf(tag);
                    if (selectedIndex > -1) {
                        selectedTags.value.splice(selectedIndex, 1);
                    }
                }
            })
                .catch(function (err) {
                var resp = err.response;
                window.$notifyError("删除失败", resp.msg);
            });
        };
        var isModifyOption = ref(false), modifyContent = ref(""), needSwitchInputOption = ref("");
        var setModifyOption = function (option) {
            modifyContent.value = option;
            needSwitchInputOption.value = option;
            isModifyOption.value = true;
        };
        var confirmModifyoption = function () {
            api.request
                .quickPost("/modifytag", {
                oldValue: needSwitchInputOption.value,
                newValue: modifyContent.value,
            })
                .then(function (res) {
                console.log("修改分类", needSwitchInputOption.value, modifyContent.value);
                var index = tagsOptions.value.indexOf(needSwitchInputOption.value);
                if (index > -1) {
                    tagsOptions.value[index] = modifyContent.value;
                    window.$message.success("修改成功");
                }
                else {
                    window.$message.error("列表出错");
                    return;
                }
                if (selectedTags.value === undefined) {
                    window.$notifyError("修改时标签初始化有误", "tag数组为 undefined");
                    return;
                }
                if (selectedTags.value.includes(needSwitchInputOption.value)) {
                    var selectedIndex = selectedTags.value.indexOf(needSwitchInputOption.value);
                    if (selectedIndex > -1) {
                        selectedTags.value[selectedIndex] = modifyContent.value;
                    }
                }
            })
                .catch(function (err) {
                var resp = err.response;
                window.$notifyError("修改失败", resp.msg);
            })
                .finally(function () {
                isModifyOption.value = false;
                needSwitchInputOption.value = "";
            });
        };
        var renderLabel = function (option) {
            return [
                h("div", {
                    class: "select-option-container",
                }, {
                    default: function () { return [
                        h("span", {
                            class: "option-label",
                            style: isModifyOption.value &&
                                needSwitchInputOption.value === option.label
                                ? { display: "none" }
                                : {},
                        }, option.label),
                        h(NInput, {
                            class: "option-modify-input",
                            style: !(isModifyOption.value &&
                                needSwitchInputOption.value === option.label)
                                ? { display: "none" }
                                : {},
                            value: modifyContent.value,
                            "onUpdate:value": function (val) { return (modifyContent.value = val); },
                            onClick: function (e) { return e.stopPropagation(); },
                            onMousedown: function (e) { return e.stopPropagation(); },
                            onMouseup: function (e) { return e.stopPropagation(); },
                        }),
                        h("div", {
                            class: "select-option-btn-group",
                        }, {
                            default: function () { return [
                                h(NButton, {
                                    class: "select-delete-option-btn",
                                    size: "small",
                                    onClick: function (e) {
                                        e.stopPropagation();
                                        setModifyOption(option.label);
                                    },
                                    style: isModifyOption.value &&
                                        needSwitchInputOption.value === option.label
                                        ? { display: "none" }
                                        : {},
                                }, {
                                    icon: function () {
                                        return h(NIcon, { size: "1.2rem" }, function () {
                                            return h(CustomSVG, {
                                                icon: "Edit",
                                                class: "delete-option-icon",
                                            });
                                        });
                                    },
                                }),
                                h(NButton, {
                                    class: "select-delete-option-btn",
                                    size: "small",
                                    onClick: function (e) {
                                        e.stopPropagation();
                                        confirmModifyoption();
                                    },
                                    style: !(isModifyOption.value &&
                                        needSwitchInputOption.value === option.label)
                                        ? { display: "none" }
                                        : {},
                                }, {
                                    icon: function () {
                                        return h(NIcon, { size: "1.2rem" }, function () {
                                            return h(CustomSVG, {
                                                icon: "Check",
                                                class: "delete-option-icon",
                                            });
                                        });
                                    },
                                }),
                                h(NButton, {
                                    class: "select-delete-option-btn",
                                    size: "small",
                                    onClick: function (e) {
                                        e.stopPropagation();
                                        deleteOption(option.label);
                                    },
                                }, {
                                    icon: function () {
                                        return h(NIcon, { size: "1.2rem" }, function () {
                                            return h(CustomSVG, {
                                                icon: "Delete24Filled",
                                                class: "delete-option-icon",
                                            });
                                        });
                                    },
                                }),
                            ]; },
                        }),
                    ]; },
                }),
            ];
        };
        onMounted(function () {
            console.log("mounted");
            console.log("selectedTags", selectedTags.value);
        });
        return function (_ctx, _cache) {
            var _component_n_select = _resolveComponent("n-select");
            return (_openBlock(), _createBlock(_component_n_select, {
                value: selectedTags.value,
                "onUpdate:value": _cache[1] || (_cache[1] = function ($event) { return ((selectedTags).value = $event); }),
                multiple: "",
                options: tagsRenderOptions.value,
                placeholder: "选择标签（可输入过滤）",
                filterable: true,
                "max-tag-count": "responsive",
                "render-label": renderLabel,
                "onUpdate:show": _cache[2] || (_cache[2] = function ($event) { return (isModifyOption.value = false); })
            }, {
                header: _withCtx(function () { return [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(_unref(NInput), {
                            value: newTagInput.value,
                            "onUpdate:value": _cache[0] || (_cache[0] = function ($event) { return ((newTagInput).value = $event); }),
                            placeholder: "添加新标签"
                        }, null, 8, ["value"]),
                        _createVNode(_unref(NButton), {
                            onClick: addNewTag,
                            size: "small",
                            type: "primary",
                            class: "add-new-option-button"
                        }, {
                            icon: _withCtx(function () { return [
                                _createVNode(_unref(NIcon), null, {
                                    default: _withCtx(function () { return [
                                        _createVNode(CustomSVG, {
                                            icon: "Check",
                                            class: "add-option-btn-icon"
                                        })
                                    ]; }),
                                    _: 1
                                })
                            ]; }),
                            _: 1
                        })
                    ])
                ]; }),
                _: 1
            }, 8, ["value", "options"]));
        };
    }
});
